import { StringMap } from '@/shared/utils/map'
import { FormAttributeDefinition } from '@/shared/forms/form-attribute-definition'

export function serialize<T>(
  input: StringMap<any>,
  attributes: FormAttributeDefinition[]
): StringMap<any> {
  const result: StringMap<any> = {}

  for (const attribute of attributes) {
    attribute.serialize(result, attribute, input[attribute.name])
  }

  return result
}
